import { useNavigate } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import { useSidebar } from "design-system/organisms/Sidebar"
import { useTrackEvent } from "lib/mixpanel"
import { TRACKING_EVENTS } from "lopermut"
import { Gift } from "lucide-react"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { useSubscriptionData } from "modules/subscription/hooks/useSubscriptionData"
import { canSeeReferrals } from "modules/subscription/lib/canSeeReferrals"
import { useTranslation } from "react-i18next"
import { hasBackofficeAccess } from "schema"

type Props = {
  embedded?: boolean
}

export function SidebarReferralButton({ embedded = false }: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const trackEvent = useTrackEvent()
  const { state, isMobile } = useSidebar()
  const { data: employee } = useAuthEmployeeQuery()
  const { activeSubscriptionName } = useSubscriptionData()

  if (!employee || hasBackofficeAccess(employee.backofficeType)) {
    return null
  }

  if (!canSeeReferrals(employee, activeSubscriptionName)) {
    return null
  }

  const isExpanded = state === "expanded" || isMobile
  const shouldShowLabel = embedded || isExpanded

  return (
    <div className={embedded ? "w-full" : "px-2 pb-2"}>
      <Button
        variant="outline"
        onClick={() => {
          trackEvent(TRACKING_EVENTS.REFERRALS_GET_FREE_CREDITS_CLICKED)
          navigate({ to: "/settings/subscription/referrals" })
        }}
        className="h-10 font-normal gap-3 w-full justify-start hover:bg-primary/5 px-5"
      >
        <Gift className="h-4 w-4 shrink-0" />
        {shouldShowLabel && <span>{t("subscription.referrals.button")}</span>}
      </Button>
    </div>
  )
}
